import { render } from "./RankingLastYear.vue?vue&type=template&id=254a071b&scoped=true"
import script from "./RankingLastYear.vue?vue&type=script&lang=js"
export * from "./RankingLastYear.vue?vue&type=script&lang=js"

import "@/assets/css/style_parts.css?vue&type=style&index=0&id=254a071b&lang=css&scoped=true"
import "@/assets/css/style_ranking_last_year.css?vue&type=style&index=1&id=254a071b&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254a071b"]])

export default __exports__